import { isArray, join, map } from "lodash";

export interface CustomComponentProps {
  data: string | string[];
}

export const renderCustomComponent = ({ data }: CustomComponentProps) => {
  if (typeof data === "string") {
    return data;
  }

  if (typeof data === "object" && data !== null && "name" in data) {
    return data.name;
  }

  if (isArray(data) && data.length > 0) {
    const valuesArray = map(data, "name");
    const values = join(valuesArray, ", ");
    return values;
  }

  return null;
};
